<template>
  <!--  &lt;!&ndash; Container &ndash;&gt;-->
  <!--  <div class="max-w-screen-xl mx-auto px-4">-->
  <!--    &lt;!&ndash; Grid wrapper &ndash;&gt;-->
  <!--    <div class="-mx-4 flex flex-wrap">-->
  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="w-full flex flex-col p-4 sm:w-1/2 lg:w-1/3">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="w-full flex flex-col p-4 sm:w-1/2 lg:w-1/3">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->
  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="w-full flex flex-col p-4 sm:w-1/2 lg:w-1/3">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->
  <!--    </div>-->
  <!--  </div>-->


  <!--  &lt;!&ndash; Container &ndash;&gt;-->
  <!--  <div class="max-w-screen-xl mx-auto px-4">-->
  <!--    &lt;!&ndash; Grid wrapper &ndash;&gt;-->
  <!--    <div class="-mx-4 flex flex-wrap">-->

  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="w-full flex flex-col p-4 sm:w-1/2 lg:w-1/3" style="background-color: #e76e3c; height: 350px;">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->

  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="w-full flex flex-col p-4 sm:w-1/2 lg:w-1/3" style="background-color: #e76e3c; height: 250px;">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->

  <!--    </div>-->

  <!--  </div>-->


  <!--  &lt;!&ndash; Container &ndash;&gt;-->
  <!--&lt;!&ndash;  <div class="max-w-screen-2xl mx-auto px-4">&ndash;&gt;-->
  <!--  <div class="w-10/12 mx-auto px-4">-->
  <!--    &lt;!&ndash; Grid wrapper &ndash;&gt;-->
  <!--    <div class="-mx-4 flex flex-wrap">-->

  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="flex flex-col p-4 w-1/2" style="background-color: #e76e3c; height: 350px;">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->

  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="flex flex-col p-4 w-1/2" style="background-color: #e76e3c; height: 250px;">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->

  <!--    </div>-->

  <!--  </div>-->


  <!--https://laravel-news.com/tailwind-css-tips-and-tricks -->
  <!-- Container -->
  <!--  <div class="max-w-screen-2xl mx-auto px-4">-->
  <!--  <div class="w-10/12 mx-auto px-4">-->
  <!--    &lt;!&ndash; Grid wrapper &ndash;&gt;-->
  <!--    <div class="-mx-4 flex flex-wrap">-->

  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="flex flex-col p-4 w-1/2" style="background-color: #e76e3c;">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->

  <!--      &lt;!&ndash; Grid column &ndash;&gt;-->
  <!--      <div class="flex flex-col p-4 w-1/2" style="background-color: #e76e3c;">-->
  <!--        &lt;!&ndash; Column contents &ndash;&gt;-->
  <!--        <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
  <!--          &lt;!&ndash; Card contents &ndash;&gt;-->
  <!--        </div>-->
  <!--      </div>-->

  <!--    </div>-->

  <!--  </div>-->


  <!--  -->

  <div class="resume">
    <!-- Container -->
    <!--  <div class="max-w-screen-2xl mx-auto px-4">-->

    <!--    ok voor nu-->
    <!--    <div class="w-10/12 mx-auto px-4">-->

<!--    https://codepen.io/ScottWhittaker/pen/vrymgg -->
<!--    <form class="flex flex-wrap bg-blue-500 p-4">-->
<!--      &lt;!&ndash; Input container &ndash;&gt;-->
<!--      <div class="w-full md:w-1/2 p-4">-->
<!--        <div class="bg-red-500 p-4">-->
<!--          <label for="input1">Label</label>-->
<!--          <input type="text" name="input1" class="w-full p-2" value="Hello world1!">-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; Input container &ndash;&gt;-->
<!--      <div class="w-full md:w-1/2 p-4">-->
<!--        <div class="bg-red-500 p-4">-->
<!--          <label for="input2">Label</label>-->
<!--          <input type="text" name="input2" class="w-full p-2" value="Hello world2!">-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; Input container &ndash;&gt;-->
<!--      <div class="w-full md:w-1/2 p-4">-->
<!--        <div class="bg-red-500 p-4">-->
<!--          <label for="input3">Label</label>-->
<!--          <input type="text" name="input3" class="w-full p-2" value="Hello world3!">-->
<!--        </div>-->
<!--      </div>-->
<!--      &lt;!&ndash; Input container &ndash;&gt;-->
<!--      <div class="w-full md:w-1/2 p-4">-->
<!--        <div class="bg-red-500 p-4">-->
<!--          <label for="input4">Label</label>-->
<!--          <input type="text" name="input4" class="w-full p-2" value="Hello world4!">-->
<!--        </div>-->
<!--      </div>-->
<!--    </form>-->

<!--    <div class="2xl:w-10/12 xl:w-full mx-auto px-4">-->
    <div class="w-full 2xl:w-10/12 mx-auto px-4">

      <!-- Grid wrapper -->
<!--      <div class="-mx-4 flex flex-wrap">-->
      <div class="-mx-4 flex flex-wrap">

        <!-- Grid column 1 -->
<!--        <div class="flex flex-col p-4 w-4/12" style="background-color: #424242!important; border-color: #424242!important;">-->
        <div class="flex p-4 w-full xl:w-4/12 " style="background-color: #424242!important; border-color: #424242!important;">
          <!-- Column contents -->

          <!--          <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
          <div class="flex-1 text-white">
            <!-- Card contents -->

            <!-- begin part 1 -->

            <div>

              <div class="text-center">
                <div class="inline-flex items-center justify-center text-center align-middle relative"
                     style="height: 120px; width: 120px;">
                  <img alt="Vue logo" src="../assets/logo.png" class="rounded-full"/>
                </div>
              </div>

              <div>
                <div class="text-center mt-4 mb-6">
                  <h1 class="text-3xl">Filip <span class="text-lightBlue-500 font-bold">Vanden Eynde</span></h1>
                  <p>A challenge-loving web developer</p>
                </div>
              </div>


            </div>

            <!-- end part 1 -->


            <!-- begin part 2 -->

            <div class="text-white">
              <!-- Card contents -->

              <div class="text-left w-full">
                <!--              <div class="inline-flex items-center justify-center text-center align-middle relative">-->
                <div class="">
                  <h2 class="border-gray-400 border-solid border-b-2 font-light leading-normal tracking-widest">
                    INFO</h2>
                </div>
              </div>

              <div>
                <!--              <div class="flex items-center">-->
                <div class="flex py-4">
                  <div
                      class="inline-flex flex-shrink-0 items-center justify-center leading-none align-text-bottom text-white mr-6 text-xl">
                    <font-awesome-icon :icon="['fas', 'envelope']"></font-awesome-icon>
                  </div>
                  <div>
                    <!--                  <span class="block text-base font-bold">Email: <span class="block text-gray-500">filipve@outlook.com</span></span>-->
                    <span class="block text-base ">Email: <span
                        class="font-normal text-gray-500">filipve@outlook.com</span></span>
                  </div>
                </div>
              </div>

              <div>
                <!--              <div class="flex items-center">-->
                <div class="flex py-4">
                  <div
                      class="inline-flex flex-shrink-0 items-center justify-center leading-none align-text-bottom text-white mr-6 text-xl">
                    <font-awesome-icon :icon="['fas', 'globe']"></font-awesome-icon>
                  </div>
                  <div>
                    <span class="block text-base ">Website: <span
                        class="font-normal text-gray-500">amirreza.in</span></span>
                  </div>
                </div>
              </div>

              <div>
                <!--              <div class="flex items-center">-->
                <div class="flex py-4">
                  <div
                      class="inline-flex flex-shrink-0 items-center justify-center leading-none align-text-bottom text-white mr-6 text-xl">
                    <font-awesome-icon :icon="['fas', 'birthday-cake']"></font-awesome-icon>
                  </div>
                  <div>
                    <span class="block text-base ">Birth Date: <span class="font-normal text-gray-500">20/04/1994</span></span>
                  </div>
                </div>
              </div>

              <div>
                <!--              <div class="flex items-center">-->
                <div class="flex py-4">
                  <div
                      class="inline-flex flex-shrink-0 items-center justify-center leading-none align-text-bottom text-white mr-6 text-xl">
                    <font-awesome-icon :icon="['fas', 'map-marker-alt']"></font-awesome-icon>
                  </div>
                  <div>
                    <span class="block text-base ">Location: <span
                        class="font-normal text-gray-500">Belgium</span></span>
                  </div>
                </div>
              </div>


            </div>
            <!-- end part 2 -->

            <!-- begin part 3 -->

            <div class="text-white">
              <!-- Card contents -->

              <div class="text-left w-full">
                <!--              <div class="inline-flex items-center justify-center text-center align-middle relative">-->
                <div class="">
                  <h2 class="border-gray-400 border-solid border-b-2 font-light leading-normal tracking-widest">
                    SOCIALS</h2>
                </div>
              </div>

              <div>
                <!--              <div class="flex items-center">-->
                <div class="flex py-4">
                  <div
                      class="inline-flex flex-shrink-0 items-center justify-center leading-none align-text-bottom text-white mr-6 text-xl">
                    <font-awesome-icon :icon="['fab', 'github']"></font-awesome-icon>
                  </div>
                  <div>
                    <p><a href="#" target="_blank" class="font-normal text-gray-500">github.com/AmirrezaNasiri</a></p>
                  </div>
                </div>
              </div>

              <div>
                <!--              <div class="flex items-center">-->
                <div class="flex py-4">
                  <div
                      class="inline-flex flex-shrink-0 items-center justify-center leading-none align-text-bottom text-white mr-6 text-xl">
                    <font-awesome-icon :icon="['fab', 'linkedin']"></font-awesome-icon>
                  </div>
                  <div>
                    <p><a href="#" target="_blank" class="font-normal text-gray-500">github.com/AmirrezaNasiri</a></p>
                  </div>
                </div>
              </div>

              <div>
                <!--              <div class="flex items-center">-->
                <div class="flex py-4">
                  <div
                      class="inline-flex flex-shrink-0 items-center justify-center leading-none align-text-bottom text-white mr-6 text-xl">
                    <font-awesome-icon :icon="['fab', 'twitter']"></font-awesome-icon>
                  </div>
                  <div>
                    <p><a href="#" target="_blank" class="font-normal text-gray-500">github.com/AmirrezaNasiri</a></p>
                  </div>
                </div>
              </div>

              <div>
                <!--              <div class="flex items-center">-->
                <div class="flex py-4">
                  <div
                      class="inline-flex flex-shrink-0 items-center justify-center leading-none align-text-bottom text-white mr-6 text-xl">
                    <font-awesome-icon :icon="['fab', 'instagram']"></font-awesome-icon>
                  </div>
                  <div>
                    <p><a href="#" target="_blank" class="font-normal text-gray-500">github.com/AmirrezaNasiri</a></p>
                  </div>
                </div>
              </div>


            </div>

            <!-- end part 3 -->

            <!-- begin part 4 -->

            <div class="text-white">
              <!-- Card contents -->

              <div class="text-left w-full">
                <!--              <div class="inline-flex items-center justify-center text-center align-middle relative">-->
                <div class="">
                  <h2 class="border-gray-400 border-solid border-b-2 font-light leading-normal tracking-widest">
                    HOBBIES</h2>
                </div>
              </div>

              <div class="py-4 flex flex-wrap text-white">
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'bullseye']"></font-awesome-icon> </span> Getting out of the Safe Zone
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'biohazard']"></font-awesome-icon> </span> Challenges
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'biking']"></font-awesome-icon> </span> Cycling
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'mountain']"></font-awesome-icon> </span> Nature
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'skiing']"></font-awesome-icon> </span> Skiing
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'magic']"></font-awesome-icon> </span> Hacking Stuff
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon
                      :icon="['fas', 'chalkboard-teacher']"></font-awesome-icon> </span> Teaching
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'users']"></font-awesome-icon> </span> Leadership
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'music']"></font-awesome-icon> </span> Music
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'book-open']"></font-awesome-icon> </span> Books
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'bug']"></font-awesome-icon> </span> Making Bugs!
                </span>
                <span class="m-1 bg-gray-500 hover:bg-gray-600 rounded-full px-2  text-sm leading-loose cursor-pointer">
                  <span class="mr-1"> <font-awesome-icon :icon="['fas', 'code']"></font-awesome-icon> </span> Coding
                </span>


              </div>

            </div>

            <!-- end part 4 -->

            <!-- begin part 5 -->
            <div class="text-white">
              <!-- Card contents -->

              <div class="text-left w-full">
                <!--              <div class="inline-flex items-center justify-center text-center align-middle relative">-->
                <div class="">
                  <h2 class="border-gray-400 border-solid border-b-2 font-light leading-normal tracking-widest">
                    LANGUAGES</h2>
                </div>
              </div>

              <div class="py-4 flex text-white">
                <table class="table-auto">
                  <thead>
                  <tr>
                    <th>Language</th>
                    <th>Understanding</th>
                    <th>Speaking</th>
                    <th>Writing</th>
                  </tr>
                  </thead>
                  <tbody>
                  <tr>
                    <td>Dutch</td>
                    <td>Mothertongue</td>
                    <td>Mothertongue</td>
                    <td>Mothertongue</td>
                  </tr>
                  <tr class="bg-emerald-200">
                    <td>English</td>
                    <td>Mothertongue</td>
                    <td>Mothertongue</td>
                    <td>Mothertongue</td>
                  </tr>
                  <tr>
                    <td>French</td>
                    <td>Mothertongue</td>
                    <td>Mothertongue</td>
                    <td>Mothertongue</td>
                  </tr>
                  </tbody>
                </table>
              </div>

            </div>

            <!-- end part 5 -->

            <!-- begin part 6 -->


            <!-- end part 6 -->

          </div>

        </div>

        <!-- Grid column 2 -->
<!--        <div class="flex flex-col p-4 w-8/12" style="background-color: #f5f5f5!important;border-color:#f5f5f5!important;">-->
        <div class="flex p-4 w-full xl:w-8/12" style="background-color: #f5f5f5!important;border-color:#f5f5f5!important;">

          <!-- Column contents -->
          <!--          <div class="flex-1 px-10 py-12 bg-white rounded-lg shadow-lg">-->
          <div class="flex-1 bg-white rounded-lg shadow-lg">

            <div class="whoami p-4">
              <div class="flex flex-initial">
                <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">Who am
                  I?</h3>
              </div>

              <div class="">
                <p>I'm a developer born in Iran and founder of Delix.ir, Bytegate.io and Bobet.ir and co-founder of
                  Smo.li.</p>
                <p>I'm interested and skilled in different topics of Information Technology, including programming, web
                  development, and computer and network security.</p>
              </div>
            </div>

            <!--            -->

            <div class="proudof p-4">
              <div class="flex flex-initial">
                <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">What am
                  I proud of?</h3>
              </div>

              <div class="text p-4 text-black">

                <div>
                  <!--              <div class="flex items-center">-->
                  <div class="flex py-4">
                    <div
                        class="inline-flex flex-shrink-0 items-center items-baseline justify-center leading-none align-text-bottom text-black mr-6 text-xl">
                      <font-awesome-icon :icon="['fas', 'question-circle']"></font-awesome-icon>
                    </div>
                    <div class="">
                      <p class="text-l font-bold">Answered 10M+ questions!</p>
                      <small>hoi hoi</small>
                    </div>
                  </div>
                </div>

                <div>
                  <!--              <div class="flex items-center">-->
                  <div class="flex py-4">
                    <div
                        class="inline-flex flex-shrink-0 items-center items-baseline justify-center leading-none align-text-bottom text-black mr-6 text-xl">
                      <font-awesome-icon :icon="['fas', 'music']"></font-awesome-icon>
                    </div>
                    <div class="">
                      <p class="text-l font-bold">Made people enjoy and learn a new language for equivalent of 29+ years
                        (older than myself!)
                      </p>
                      <small>hoi hoi</small>
                    </div>
                  </div>
                </div>


                <div>
                  <!--              <div class="flex items-center">-->
                  <div class="flex py-4">
                    <div
                        class="inline-flex flex-shrink-0 items-center items-baseline justify-center leading-none align-text-bottom text-black mr-6 text-xl">
                      <font-awesome-icon :icon="['fas', 'hourglass-start']"></font-awesome-icon>
                    </div>
                    <div class="">
                      <p class="text-l font-bold">Saved +110 days of time of students, writers and etc!
                      </p>
                      <small>hoi hoi</small>
                    </div>
                  </div>
                </div>

                <div>
                  <!--              <div class="flex items-center">-->
                  <div class="flex py-4">
                    <div
                        class="inline-flex flex-shrink-0 items-center items-baseline justify-center leading-none align-text-bottom text-black mr-6 text-xl">
                      <font-awesome-icon :icon="['fas', 'user-friends']"></font-awesome-icon>
                    </div>
                    <div class="">
                      <p class="text-l font-bold">Tried to cover small part of 7 people expenses.</p>
                      <small>hoi hoi</small>
                    </div>
                  </div>
                </div>

              </div>
            </div>

            <!--            -->

            <div class="education p-4">
              <div class="flex flex-initial">
                <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">
                  Education</h3>
              </div>

              <div class="text text-black">

                <div class="flex flex-wrap overflow-hidden">

                  <!--                  <div class="w-1/2 overflow-hidden">-->
                  <div class="w-4/12 overflow-hidden">
                    <!-- Column Content -->
                    2015 - 2019 (not finished yet)
                  </div>

                  <!--                  <div class="w-1/2 overflow-hidden">-->
                  <div class="w-8/12 overflow-hidden">
                    <!-- Column Content -->
                    <strong>Bachelor's degree, Information Technology</strong>
                    <div>
                      <i>Seraj University</i>
                    </div>
                    <div>Became a member of University Academic Association of Computer Science</div>
                  </div>

                </div>


              </div>
            </div>

            <!--            -->

            <div class="skills p-4" id="to-timeline">
              <div class="flex flex-initial">
                <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">Skills
                  and Expertize</h3>
              </div>

              <div class="text text-black">

                <div class="flex flex-wrap overflow-hidden">

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'php']"></font-awesome-icon>
                          php
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'php']"></font-awesome-icon>
                          php
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'php']"></font-awesome-icon>
                          php
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'php']"></font-awesome-icon>
                          php
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-full mb-6"></div>


                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>


                  <div class="w-full mb-6"></div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                  <div class="w-full mb-6"></div>

                  <div class="w-6/12 overflow-hidden mb-4">
                    <!-- Column Content -->

                    <!-- skill begin -->
                    <div class="mr-2 ml-2">
                      <div class="items-center leading-none mb-1">
                        <div class="">
                          <font-awesome-icon :icon="['fab', 'ubuntu']"></font-awesome-icon>
                          Ubuntu
                        </div>
                      </div>

                      <!--  https://tailwindcomponents.com/component/progress-bar-1 -->
                      <div class="mt-0 bg-gray-600 bg-gray-700 rounded-full bg-opacity-30" style="height: 3px;">
                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full"></div>
                        <!--                        <div class="w-9/12 mt-0 bg-gray-700 py-1 rounded-full" style="width: 95%;"></div>-->
                      </div>

                    </div>
                    <!-- skill end -->

                  </div>

                </div>


              </div>
            </div>


            <!-- Card contents -->
          </div>
        </div>

      </div>

      <div class="layout -mx-4 flex bg-warmGray-50">

        <div class="flex flex-wrap overflow-hidden  p-4">

          <div id="timeline" class="w-full mb-4 flex-auto bg-white rounded-lg shadow-lg" style="height:400px;">

            <div class="whoami p-4" id="to-portfolio">
              <div class="flex flex-initial" id="portfolio">
                <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">
                  Portfolio</h3>
              </div>

              <div class="">
                <p>I'm a developer born in Iran and founder of Delix.ir, Bytegate.io and Bobet.ir and co-founder of
                  Smo.li.</p>
                <p>I'm interested and skilled in different topics of Information Technology, including programming, web
                  development, and computer and network security.</p>
              </div>
            </div>


          </div>

          <div class="w-full mb-4 flex-auto bg-white rounded-lg shadow-lg" style="height:400px;">

            <div class="whoami p-4">
              <div class="flex flex-initial">
                <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">My Life
                  in a Nutshell</h3>
              </div>

              <div class="">
                <p>I'm a developer born in Iran and founder of Delix.ir, Bytegate.io and Bobet.ir and co-founder of
                  Smo.li.</p>
                <p>I'm interested and skilled in different topics of Information Technology, including programming, web
                  development, and computer and network security.</p>
              </div>
            </div>


          </div>

          <div class="w-full mb-4 flex-auto bg-white rounded-lg shadow-lg" style="height:400px;">

            <div class="whoami p-4">
              <div class="flex flex-initial">
                <h3 class="text-2xl mb-6 border-b-2 border-solid border-gray-400 text-gray-600 font-light mb-1">Who am
                  I?</h3>
              </div>

              <div class="">
                <p>I'm a developer born in Iran and founder of Delix.ir, Bytegate.io and Bobet.ir and co-founder of
                  Smo.li.</p>
                <p>I'm interested and skilled in different topics of Information Technology, including programming, web
                  development, and computer and network security.</p>
              </div>

<!--              <div class="title-container">-->
<!--                <div>-->
<!--                  <h3 class="title">-->
<!--                    Our Projects-->
<!--                  </h3>-->
<!--                </div>-->
<!--                <div class="filters">-->
<!--                  <span class="filter" v-bind:class="{ active: currentFilter === 'ALL' }" v-on:click="setFilter('ALL')">ALL</span>-->
<!--                  <span class="filter" v-bind:class="{ active: currentFilter === 'ART' }" v-on:click="setFilter('ART')">ART</span>-->
<!--                  <span class="filter" v-bind:class="{ active: currentFilter === 'WORKSHOPS' }" v-on:click="setFilter('WORKSHOPS')">WORKSHOPS</span>-->
<!--                  <span class="filter" v-bind:class="{ active: currentFilter === 'FUN' }" v-on:click="setFilter('DOODLES')">DOODLES</span>-->
<!--                </div>-->
<!--              </div>-->

<!--              <transition-group class="projects" name="projects" >-->
<!--                <div class="project" v-if="currentFilter === project.category || currentFilter === 'ALL'"-->
<!--                     v-bind:key="project.title" v-for="project in projects">-->
<!--                  <div class="project-image-wrapper">-->
<!--                    <img class="project-image" v-bind:src="project.image">-->
<!--                    <div class="gradient-overlay"></div>-->
<!--                    <div class="circle">-->
<!--                      <span class="project-title">{{project.title}}</span>-->
<!--                    </div>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </transition-group>-->



            </div>


          </div>

        </div>

      </div>


    </div>

  </div>
</template>

<script>
// import TweenMax from "gsap";
import LeaderLine from 'leader-line-new';
import datajsimport from "./resumedata";


export default {
  name: "Resume2",
  components: {

  },
  data() {

    return datajsimport
    // return {
    //   datajsimport,
    //
    //   users: usersData,
    //   datajs: datajsimport.data,
    //
    //
    //
    //   currentFilter: 'ALL',
    //   projects: [
    //     {title: "Artwork", image: "https://picsum.photos/g/200?image=122", category: 'ART'},
    //     {title: "Charcoal", image: "https://picsum.photos/g/200?image=116", category: 'ART'},
    //     {title: "Sketching", image: "https://picsum.photos/g/200?image=121", category: 'DOODLES'},
    //     {title: "Acrillic", image: "https://picsum.photos/g/200?image=133", category: 'WORKSHOPS'},
    //     {title: "Pencil", image: "https://picsum.photos/g/200?image=134", category: 'DOODLES'},
    //     {title: "Pen", image: "https://picsum.photos/g/200?image=115", category: 'ART'},
    //     {title: "Inking", image: "https://picsum.photos/g/200", category: 'WORKSHOPS'},
    //   ]
    //
    // }
  },

  created() {

  },
  mounted() {


    this.drawline();

    // this.drawline2();

  },
  methods: {
    setFilter: function(filter) {
      this.currentFilter = filter;
    },

    drawline() {
      // eslint-disable-next-line no-unused-vars

      const start = document.getElementById('to-timeline');
      const end = document.getElementById('timeline');
      const line = new LeaderLine(
          {
            start: start,
            end: end,
            size: 2,
            // color     : this.$vuetify.theme.primary,
            color: '#1976D2',
            startLabel: LeaderLine.captionLabel('To the Journey ...'),
          });
    },
    drawline2() {
      // eslint-disable-next-line no-unused-vars
      const start = document.getElementById('to-portfolio');
      const end = document.getElementById('portfolio');
      const line = new LeaderLine(
          {
            start: start,
            end: end
          }
      );
    }
  },
}
</script>

<style scoped lang="scss">
.resume, body {
  height: 100%;
  background: #66668d;
  background: -webkit-gradient(linear, right top, left top, from(#66668d), to(#4389a2));
  background: linear-gradient(
          270deg, #66668d, #4389a2);
  background-size: cover;

}


//




.title-container {
  display:flex;
  flex-direction:column;
  justify-content:center;
  align-items:center;
}

.title {
  font-family: 'Dawning of a New Day', cursive;
  font-size:30pt;
  font-weight:normal;
}

.project-title {
  font-size:16pt
}

.filter {
  font-family:arial;
  padding: 6px 6px;
  cursor:pointer;
  border-radius: 6px;
  transition: all 0.35s;
}

.filter.active {
  box-shadow:0px 1px 3px 0px #00000026;
}

.filter:hover {
  background:lightgray;
}

.projects {
  margin-bottom:50px;
  margin-top:25px;
  display:flex;
  flex-wrap:wrap;
  justify-content:center;
}

.projects-enter {
  transform: scale(0.5) translatey(-80px);
  opacity:0;
}

.projects-leave-to{
  transform: translatey(30px);
  opacity:0;
}

.projects-leave-active {
  position: absolute;
  z-index:-1;
}

.circle {
  text-align:center;
  position:absolute;
  bottom:-38px;
  left:40px;
  width:100px;
  height:100px;
  border-radius:50px;
  /* 	border:1px solid black; */
  display:flex;
  box-shadow: 0px -4px 3px 0px #494d3257;
  justify-content:center;
  align-items:center;
  background-color:#fff;
  /* 	box-shadow:0px -3px 3px #484848a6; */
}

.project {
  transition: all .35s ease-in-out;
  margin:10px;
  box-shadow:0px 2px 8px lightgrey;
  border-radius:3px;
  width:180px;
  height:200px;
  display:flex;
  flex-direction:column;
  align-items:center;
}

.project-image-wrapper {
  position:relative;
}

.gradient-overlay {
  position:absolute;
  top:0;
  left:0;
  width:100%;
  height:150px;
  opacity:0.09;
  background:
      linear-gradient(to bottom, rgba(0,210,247,0.65) 0%,rgba(0,210,247,0.64) 1%,rgba(0,0,0,0) 100%),
      linear-gradient(to top, rgba(247,0,156,0.65) 0%,rgba(247,0,156,0.64) 1%,rgba(0,0,0,0) 100%);
  border-bottom-left-radius:10px;
  border-bottom-right-radius:10px;
  border-top-left-radius:3px;
  border-top-right-radius:3px;
}

.project-image {
  width:100%;
  height:150px;
  border-bottom-left-radius:5px;
  border-bottom-right-radius:5px;
  border-top-left-radius:3px;
  border-top-right-radius:3px;
}
</style>
